import { colors, sxPresets } from '@/theme'
import type { Investigation } from '@/types/investigation'
import { ExpandMore } from '@mui/icons-material'
import { Box, Collapse, IconButton, Paper, Typography } from '@mui/material'
import { useState } from 'react'

interface MedicalHistoryProps {
  investigation: Investigation
}

export default function MedicalHistory({ investigation }: MedicalHistoryProps) {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <Paper id='medical-history' elevation={0} sx={{ border: `1px solid ${colors.border.default}` }}>
      <Box sx={{ ...sxPresets().section.header, cursor: 'pointer' }} onClick={() => setIsExpanded(!isExpanded)}>
        <Typography variant='sectionTitle'>Medical History</Typography>
        <IconButton
          size='small'
          sx={{ ...sxPresets().expandButton, transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
        >
          <ExpandMore />
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ ...sxPresets().section.content, ...sxPresets().grid.twoColumn }}>
          <Box>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Medications
            </Typography>
            <Typography variant='fieldValue'>{investigation.medications}</Typography>
          </Box>
          <Box>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Allergies
            </Typography>
            <Typography variant='fieldValue'>{investigation.allergies}</Typography>
          </Box>
          <Box>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Family History
            </Typography>
            <Typography variant='fieldValue'>{investigation.familyHistory}</Typography>
          </Box>
          <Box>
            <Typography variant='fieldLabel' sx={{ display: 'block', mb: 0.5 }}>
              Conditions
            </Typography>
            <Typography variant='fieldValue'>{investigation.conditions}</Typography>
          </Box>
        </Box>
      </Collapse>
    </Paper>
  )
}
